<template>
  <div class="zhaobiao">
      <gxjyheader></gxjyheader>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
        <el-breadcrumb-item :to="{ path: '/gxjy' }">供需信息</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/zixun' }">供需资讯</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-form ref="form" :model="form" style="background: #fff;margin: 20px 0;padding:10px 0" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="标题名称" >
                <el-input placeholder="请输入"   style="width: 218px" v-model="form.title"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资讯分类">
                <el-select v-model="form.typeId" placeholder="请选择">
                  <el-option
                      v-for="item in getIndustryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="日期范围">
                <el-date-picker
                    class="riqi"
                    v-model="form.date"
                    type="datetimerange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    :clearable="false"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" size="small" @click="loadlist(true)">筛选</el-button>
            <el-button @click="reset" size="small" >重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="lists">
        <div class="list flex" v-for="(item,index) in items" @click="gotoxq(item)">
<!--          <div class="images"><el-image :src="item.images"></el-image></div>-->
          <div style="width: 80px;text-align: center;position: relative"><span  class="gong">供</span><span class="xu">需</span></div>
          <div class="flex-1">
            <div class="title ellipsis2">{{item.title}}</div>
            <div class="time flex">
              <div class="flex-1 color1">{{item.enterpriseName}}</div>
              <div>{{item.createTime}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="fenye">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page.current"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="page.size"
            :total="page.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import gxjyheader from './gxjyheader'
import {
  getIndustryList,
  getTypeList,
  submitconsult, supplydemandgetTypeList,
  supplydemandlist,
  tenderinglist
} from "../../request/moudle/demand";
export default {
  name: "zhaobiao",
  data(){
    return {
      form:{
        date:[],
        typeId:Number(this.$route.query.typeId)
      },
      shen:{},
      zxid:'',
      rules: {
        detail: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        contacts: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },
        ]
      },
      dialogTableVisible:false,
      getIndustryList:[],
      getTypeList:[],
      props: {
        label: 'name',
        value: 'code'
      },
      page:{
        current:1,
        size:10,
        total:0
      },
      items:[],
    }
  },
  created() {
    this.loadconfig()
    this.loadlist()
  },
  methods:{
    submitForm(){
      this.shen.tenderingBiddingId=this.zxid
      this.$api.demand.submitconsult(this.shen).then((res)=>{
        this.dialogTableVisible=false
        this.$message({
          type: "success",
          message: "提交成功!"
        });
      })
    },
    zixun(item){
      this.shen={}
      this.zxid=item.tenderingBiddingId
      this.dialogTableVisible=true
    },
    gotoxq(item){
      if(item.typeId==1){
        this.$router.push({
          path:'/zhaobiaoxq',
          query:{
            id:item.id,
          }
        })
      }else if(item.typeId==2){
        this.$router.push({
          path:'/caigouxq',
          query:{
            id:item.id,
          }
        })
      }else{
        this.$router.push({
          path:'/kucunxq',
          query:{
            id:item.id,
          }
        })
      }

    },
    loadconfig(){
      this.$api.demand.supplydemandgetTypeList().then((res)=>{
        this.getIndustryList=res.data
      })
    },
    loadlist(bol){
      if(bol){
        this.page.current=1
      }
      if(this.form.date){
        this.form.startDate=this.form.date[0]
        this.form.endDate=this.form.date[1]
      }
      const obj={
        ...this.form
      }
      obj.current=this.page.current
      obj.size=this.page.size
      this.$api.demand.supplydemandlist(obj).then((res)=>{
        this.items=res.data.records
        this.page.total=res.data.total
      })
    },
    reset(){
      this.form={}
    },
    handleSizeChange(val){
      this.page.size=val
      this.loadlist()
    },
    handleCurrentChange(val) {
      this.page.current=val
      this.loadlist()
    },
    lazyLoad(node, resolve) {
      let stop_level = 2;
      let level = node.level;
      let data = node.data || {}
      let code = data.code;
      let list = [];
      let callback = () => {
        resolve((list || []).map(ele => {
          return Object.assign(ele, {
            leaf: level >= stop_level
          })
        }));
      }
      if (level == 0) {
        this.$api.index.lazylist({parentCode:'00'}).then(res => {
          list = res.data;
          callback()
        });
      } else if (level == 1) {
        this.$api.index.lazylist({parentCode:code}).then(res => {
          list = res.data;
          callback()
        });
      } else if (level == 2) {
        this.$api.index.lazylist({parentCode:code}).then(res => {
          list = res.data;
          callback()
        });
      } else {
        callback()
      }
    }
  },
  components:{
    gxjyheader
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-input{
  width: auto;
}
.zhaobiao{
  background: #F5F5F5;

}
  .content{

    width: 1200px;
    margin: 15px auto;
    .images{
      width: 160px;
      height: 120px;
      margin-right: 20px;
    }
    .gong{
      width: 24px;
      height: 24px;
      border-radius: 1px;
      background: #CCABDA;
      color: #fff;
      text-align: center;
      line-height: 24px;
      position: absolute;
      top: 20px;
      left: 5px;
      z-index: 99;
    }
    .xu{
      width: 24px;
      height: 24px;
      border-radius: 1px;
      background: #0078F2;
      color: #fff;
      text-align: center;
      line-height: 24px;
      position: absolute;
      top: 20px;
      left: 5px;
      z-index: 99;
    }
    .sxx{
      background:#FFFFFF;
      padding:30px  40px;
      margin-top: 25px;
    }
    .fenye{
      text-align: center;
      padding: 30px 0;
      background: #fff;
    }
    .lists{
      background: #fff;
      padding: 15px 30px;
      font-size: 14px;
      color: #292929;
      line-height: 30px;
      .list{
        border-top: 1px solid #D1D1D1;
        padding: 15px 0;
        cursor: pointer;
      }
      .title{
        font-size: 16px;
        font-weight: bolder;
        color: #000000;
        margin: 15px 0;
        min-height: 55px;
        margin-right: 220px;
      }
      .time{
        margin-top: 10px;
      }
      .red{
        color: red;
      }
      .color1{
        color: #0078F2;
      }
      .biao{
        display: inline-block;
        color: #0078F2;
        text-align: center;
        line-height: 24px;
        margin: 5px;
      }
      .line{
        border-left: 1px solid #292929;
        margin: 0 15px;
      }
      .button{
        text-align: center;
        margin: 15px 30px;
        margin-top: 30px;
      }
    }
  }
</style>